import useSearchParams from '../../../hooks/useSearchParams';

const deserialize = (v) => (v ? Number(v) : undefined);

const useTaskDataFromParams = () => {
  const [requestId, setRequestId] = useSearchParams({
    name: 'requestId',
    deserialize,
  });

  return { requestId, setRequestId };
};

export default useTaskDataFromParams;
